import * as React from "react";
import { useMemo } from "react";
import { KnowledgeBaseSearchResults, QuickReplyButton } from "../types";
import Carousel from "./Carousel";

interface Props {
  onClickQuickReply(quickReplyButton: QuickReplyButton): void;
  searchResults: KnowledgeBaseSearchResults;
}

export default function KnowledgeBaseMessage(props: Props) {
  const [responded, setResponded] = React.useState(false);

  const helpfulText = useMemo(
    () => props.searchResults.HelpfulButtonLabel || "This is helpful",
    [props.searchResults.HelpfulButtonLabel]
  );

  const notHelpfulText = useMemo(
    () => props.searchResults.NotHelpfulButtonLabel || "This is not helpful",
    [props.searchResults.NotHelpfulButtonLabel]
  );

  const quickReplyButtonsEnabled =
    props.searchResults.HelpfulPathId &&
    props.searchResults.NotHelpfulPathId &&
    props.onClickQuickReply;

  function onClickHelpful() {
    setResponded(true);

    props.onClickQuickReply({
      label: helpfulText,
      pathId: props.searchResults.HelpfulPathId
    });
  }

  function onClickNotHelpful() {
    setResponded(true);

    props.onClickQuickReply({
      label: notHelpfulText,
      pathId: props.searchResults.NotHelpfulPathId
    });
  }

  if (responded) {
    return null;
  }

  return (
    <div>
      <Carousel itemsPerSlide={1}>
        {props.searchResults.Articles.length > 0 &&
          props.searchResults.Articles.map(result => (
            <div key={result.Id}>
              <a
                href={result.Url}
                target="_blank"
                rel="noopener noreferrer"
                className="velaro-kb-result-link"
              >
                <div className="title">{result.Title}</div>
                <div className="description">{result.Description}</div>
              </a>
            </div>
          ))}
        {props.searchResults.Articles.length === 0 && (
          <div style={{ padding: 16 }}>
            Sorry, there are no articles matching your search request.
          </div>
        )}
      </Carousel>
      {quickReplyButtonsEnabled && (
        <div className="velaro-kb-actions">
          <button
            className="velaro-btn primary velaro-bg-primary"
            onClick={() => onClickHelpful()}
          >
            {helpfulText}
          </button>{" "}
          <button
            className="velaro-btn primary velaro-bg-primary"
            onClick={() => onClickNotHelpful()}
          >
            {notHelpfulText}
          </button>
        </div>
      )}
    </div>
  );
}
